import { Header } from 'components/Global';
import SettingsLayout from 'layouts/Settings';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { keyWiseSettingsRouteMapping } from 'utils/mappings';
import { getAllowedModule } from 'utils/utils';


interface SelectedValue {
	key: string;
}

export default function Settings() {

	const navigate = useNavigate();
	const pathname = window.location.pathname;
	const pathSegments = pathname.split('/');
	const lastSegment = pathSegments[pathSegments.length - 1];

	const [selectedSidebar, setSelectedSidebar] = useState<string>();
	const selectedCompanyPermission = useSelector(
		(state: any) => state?.userProfile?.data?.permissions
	);

	// Function to handle sidebar changes
	const sideBarChangeHandler = (selectedValue: SelectedValue) => {
		setSelectedSidebar(selectedValue.key);
		navigate(selectedValue.key);
	};

	useEffect(() => {
		const allowedSettingsModule = getAllowedModule(selectedCompanyPermission, [
			'Users',
			'Roles',
			'Company Setup'
		]);

		if (lastSegment === 'settings') {
			if (allowedSettingsModule) {
				const _key =
					keyWiseSettingsRouteMapping[
						allowedSettingsModule.toLowerCase() as keyof typeof keyWiseSettingsRouteMapping
					];

				navigate(`/settings/${_key}`);
			} else {
				navigate(`/`);
			}
		}

		setSelectedSidebar(lastSegment);
	}, [lastSegment]);

	return (
		<>
			<SettingsLayout
				onSideBarChange={sideBarChangeHandler}
				selectedSidebar={selectedSidebar}
			>
				<div>
					<Header />
					<Outlet />
				</div>
			</SettingsLayout>
		</>
	);
}
